exports = module.exports = require("../../../../apps/experimentation-ui/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ane-ChoiceGroup .ms-Label {\n  background-color: transparent;\n  color: #343f51;\n}\n.ane-ChoiceGroup .ms-ChoiceFieldGroup-flexContainer .ms-ChoiceField {\n  background-color: transparent;\n  color: #343f51;\n}", ""]);

